/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2019 Pearson Education, Inc.
( * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import config from "./config";

const piSession = window.piSession;

function sessionLogin(loginObj) {
    piSession.autologin(
        loginObj.username,
        loginObj.password,
        config.pi.clientId,
        getLoginSuccessRedirectURL()
    );
}

function getLoginSuccessRedirectURL() {
    return window.location.href;
}

function getLoginFailRedirectURL() {
    return window.location.origin + "/admintool";
}

function handleSessionChange(onChange) {
    piSession.getToken((status, token) => {
        switch (status) {
            case piSession.Success: {
                onChange(token);
                break;
            }
            case piSession.NoToken: {
                if (process.env.NODE_ENV === "development") {
                    sessionLogin({ username: "ps1_ganu", password: "Passw0rd" });
                } else {
                    window.location.replace(getLoginFailRedirectURL());
                }
                break;
            }
            default: {
                break;
            }
        }
    });
}

export function logout() {
    piSession.logout();
}

export default function init(callback) {
    piSession.initialize(config.pi.clientId, {
        checkSessionMilliseconds: 3000,
        sessionIdleTimeoutSeconds: 3600,
        autoRefresh: true
    });

    piSession.on(piSession.SessionStateKnownEvent, () =>
        handleSessionChange(callback)
    );
    piSession.on(piSession.RefreshEvent, () => handleSessionChange(callback));

    piSession.on(piSession.LogoutEvent, () => {
        window.location = getLoginFailRedirectURL();
    });
}



// WEBPACK FOOTER //
// ./src/session.initialize.js